import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./polyfills";
import { App } from "./App/App";
import "./styles/global.scss";

const container = document.getElementById("main-root");
import FaqContextAPI from "./App/components/@remote/FaqContextAPI/FaqContextAPI";

import LayoutContextAPI from "./App/components/@remote/LayoutContextAPI/LayoutContextAPI";
import CouponCodesContextAPI from "./App/components/@remote/CouponCodesContextAPI/CouponCodesContextAPI";
import RemindersContext from "./App/components/@remote/RemindersContext/RemindersContext";
import NewsletterContextAPI from "./App/components/@remote/NewsletterContextAPI/NewsletterContextAPI";
import OffersContextAPI from "./offer/context/offersContextProvider";
import { QueryClientProvider, QueryClient } from "react-query";

if (container) {
  const root = createRoot(container);
  const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: Infinity } } });

  root.render(
    <BrowserRouter>
      <React.StrictMode>
        <RemindersContext>
          <LayoutContextAPI>
            <NewsletterContextAPI>
              <CouponCodesContextAPI>
                <FaqContextAPI>
                  <OffersContextAPI>
                    <QueryClientProvider client={queryClient}>
                      <App />
                    </QueryClientProvider>
                  </OffersContextAPI>
                </FaqContextAPI>
              </CouponCodesContextAPI>
            </NewsletterContextAPI>
          </LayoutContextAPI>
        </RemindersContext>
      </React.StrictMode>
    </BrowserRouter>
  );
}
